// extracted by mini-css-extract-plugin
export default {"list":"relationship-status_list__tWZ6V"};